import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { Checkbox } from 'antd';
import './ipsMapping.css';
import Expand from '../ExpandIcon';
import PreEFormAssetMapping from '../PreEFormAssetMapping';
import AssetMappingHeader from '../PreEFormAssetMapping/AssetMappingHeader';
import tick from '../../../assets/Tick.png';

const ipscss = {
    marginLeft: '0px',
    marginRight: '0px'
};

const moveleft = {
    marginLeft: '-15px',
    alignItems: 'center'
};

/**
 * PreEFormMapping
 *
 * Renders one IPS location row (accordion) and its child assets.
 *
 * Props
 * ──────────────────────────────
 * preEFormMapping       – location mapping object with assets
 * currentFormId         – ID of the current form
 * onChangeAssetId       – called when an individual asset checkbox toggles
 * selectAllAssets       – called when location-level "select all" checkbox toggles
 * saveVisibleText       – legacy: truthy when in edit mode (inverted semantics)
 * disabled              – explicit disable flag
 * attestView            – true when in viewer/attestation mode
 * onAssetCheckboxChange – forwarded to PreEFormAssetMapping for viewer highlights
 */
const PreEFormMapping = (props) => {
    const {
        id,
        ipsLocationId,
        selected,
        preEFormMapping,
        currentFormId,
        onChangeAssetId,
        assetId,
        selectAllAssets,
        saveVisibleText,
        disabled = false,
        attestView = false,
        onAssetCheckboxChange,
    } = props;

    const [setActive,    setAtiveState]   = useState('');
    const [setBGColor,   setColorState]   = useState('white');
    const [color,        setColor1]       = useState('white');
    const [checkDisplay, setCheckDisplay] = useState('none');
    const [setHeight,    setHeightState]  = useState('0px');
    const [setRotate,    setRotateState]  = useState('accordion_icon');

    let assets = preEFormMapping.assets;

    const content = useRef(null);

    const toggleAccordion = () => {
        setAtiveState(setActive === '' ? 'active' : '');
        setHeightState(setActive === 'active' ? '0px' : `${content.current.scrollHeight}px`);
        setColorState(setActive === 'active' ? 'white' : 'white');
        setColor1(setActive === 'active' ? 'white' : 'black');
        setCheckDisplay(setActive === 'active' ? 'none' : 'flex');
        setRotateState(setActive === 'active' ? ' accordion_icon' : 'accordion_icon rotate');
    };

    // Handle location checkbox change with event propagation prevention
    const handleLocationCheckboxChange = (e) => {
        if (e) {
            e.stopPropagation();
            if (e.nativeEvent) {
                e.nativeEvent.stopImmediatePropagation();
                e.nativeEvent.preventDefault();
            }
        }
        if (typeof selectAllAssets === 'function') {
            selectAllAssets(preEFormMapping.ipsLocationId);
        }
    };

    // ─────────────────────────────────────────────────────────────
    // Sync accordion open/close state from preEFormMapping prop.
    // ─────────────────────────────────────────────────────────────
    useEffect(() => {
        if (preEFormMapping.setActive == null) return;

        const isActive = preEFormMapping.setActive === 'active';

        let targetHeight = '0px';
        if (isActive) {
            if (preEFormMapping.setHeight === 'auto' && content.current) {
                targetHeight = `${content.current.scrollHeight}px`;
            } else if (preEFormMapping.setHeight && preEFormMapping.setHeight !== '0px') {
                targetHeight = preEFormMapping.setHeight;
            } else if (content.current) {
                // Fallback: compute from DOM when no usable stored height
                targetHeight = `${content.current.scrollHeight}px`;
            }
        }

        setAtiveState(preEFormMapping.setActive);
        setHeightState(targetHeight);
        setColorState('white'); // always white per original toggleAccordion logic
        setColor1(isActive ? 'black' : 'white');
        setCheckDisplay(isActive ? 'flex' : 'none');
        setRotateState(isActive ? 'accordion_icon rotate' : ' accordion_icon');
    }, [preEFormMapping.setActive, preEFormMapping.setHeight]); // ✅ Fix 1: respond to prop changes

    return (
        <Row style={ipscss} className="tasklist--row">
            <Col lg={12} className="tasklist--description" style={moveleft}>

                <a
                    id={preEFormMapping.ipsLocationId}
                    className={`accordion ${setActive}`}
                    onClick={() => toggleAccordion()}
                >
                    <Expand className={`${setRotate}`} width="15px" fill="#777" />
                </a>
                <span style={{ marginRight: '15px' }} />

                <div className="tasklist--checkbox">
                    {preEFormMapping.enableIpsLoc ? (
                        <Checkbox
                            disabled={disabled || saveVisibleText}
                            checked={!!preEFormMapping.allAssetsSelected}
                            onChange={handleLocationCheckboxChange}
                        />
                    ) : (
                        <span className="tick--signed">
                            <img src={tick} alt="Tick" />
                        </span>
                    )}
                </div>
                <div>{preEFormMapping.ipsLocationName}</div>
            </Col>

            <Col>
                <div
                    className="col-lg-12 accordion__content"
                    ref={content}
                    style={{
                        maxHeight:     `${setHeight}`,
                        backgroundColor: `${setBGColor}`,
                        color:         `${color}`,
                        checkBoxColor: `${checkDisplay}`,
                        rotate:        `${setRotate}`,
                    }}
                >
                    <AssetMappingHeader attestView={attestView} />
                    {assets && assets.map((asset) => (
                        <PreEFormAssetMapping
                            key={asset.assetId ?? asset.assetName}
                            asset={asset}
                            currentFormId={currentFormId}
                            onChangeAssetId={onChangeAssetId}
                            preEFormMapping={preEFormMapping}
                            setActive={setActive}
                            setHeight={setHeight}
                            saveVisibleText={saveVisibleText}
                            disabled={disabled}
                            attestView={attestView}
                            onAssetCheckboxChange={onAssetCheckboxChange}
                        />
                    ))}
                </div>
            </Col>
        </Row>
    );
};

export default PreEFormMapping;